import React from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';

//Material UI
import { Divider, Paper, Typography, Grid, Button, IconButton } from '@mui/material';
import { Box, FormControll } from '@arredo/reactjs-ui'

// Icons
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import VisibilityIcon from '@mui/icons-material/Visibility';

//Components
import Table from '../../../components/table/tableAndPagination';
import { Spinner } from '@arredo/reactjs-ui';

//Hooks
import useMovement from '../../../hooks/movements/useMovement';
import { utils } from '../../../utils/utils';
import { typesTranslate, subTypesTranslate, statesTranslate, columnsAdjustment } from '../../../models/MovementEntity';

const MovementStockDetail = ({ movementId }) => {
    const { movement, loading } = useMovement(movementId);
    const history = useNavigate();
    const location = useLocation();

    const goBack = () => {
        const from = location.state?.from
        history(from || '/movements');
    };


    return (
        <Grid container spacing={1}>
            {loading &&
                <Grid style={{ margin: 8 }} size={12}>
                    <Spinner message='Buscando' />
                </Grid>
            }
            {!loading &&
                <>
                    <Grid size={12}>
                        <Box
                            icon={
                                <ArrowBackIcon />
                            }
                            onIconClick={goBack}
                            header={
                                <Typography variant='h5' component='h4'>
                                    {movement.id ? `${movement.id} | Movimiento` : 'Movimiento'}
                                </Typography>
                            }
                        >
                        </Box>
                    </Grid>
                    <Grid
                        size={{
                            xs: 4,
                            xl: 3
                        }}
                    >
                        <Box header={
                            <Typography variant='h5' component='h3'>
                                Datos del Movimiento
                            </Typography>
                        }
                        >
                            <Grid container spacing={1}>
                                <Grid size={12}>
                                    <FormControll label='Id' value={movement?.id} />
                                    <FormControll label='Estado' value={statesTranslate[movement?.state]} />
                                    <FormControll label='Tipo' value={typesTranslate[movement?.type]} />
                                    <FormControll label='Sub tipo' value={subTypesTranslate[movement?.subType]} />
                                    <FormControll label='Motivo' value={movement?.reason} />
                                    <FormControll label='Creado' value={utils.formatDate(movement?.created || '')} />
                                    <FormControll label='Usuario' value={movement?.createdBy || ''} />
                                </Grid>
                                {
                                    movement.referral &&
                                    <>
                                        <Grid size={12}>
                                            <Typography variant='h6' component='h3'>
                                                Remito
                                            </Typography>
                                        </Grid>
                                        <Grid size={12}>
                                            <Divider />
                                        </Grid>
                                        <Grid size={12}>
                                            <FormControll label='Id' value={movement.referral.id} />
                                            <FormControll label='Nro Comprobante' value={movement.referral.number} />
                                        </Grid>
                                        <Grid size={12}>
                                            <Button
                                                fullWidth
                                                color='primary'
                                                variant='outlined'
                                                size='small'
                                                component={Link}
                                                to={`/stocks/referrals/${movement.referral.id}`}
                                                endIcon={<VisibilityIcon />}
                                            >
                                                Ver
                                            </Button>
                                        </Grid>
                                    </>
                                }
                            </Grid>
                        </Box>
                    </Grid>
                    <Grid
                        size={{
                            xs: 8,
                            xl: 9
                        }}
                    >
                        <Box component={Paper} padding={2}>
                            <Grid container spacing={1}>
                                <Grid size={12}>
                                    <Typography variant='h5' component='h3'>
                                        Productos
                                    </Typography>
                                </Grid>
                                <Grid size={12}>
                                    <Table
                                        rows={movement?.details}
                                        columns={columnsAdjustment}
                                        loading={loading}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                </>
            }
        </Grid>
    );
}

export default MovementStockDetail;